import MenuButton from "../MenuButton";
import CustomerStatusMenu from "./CustomerStatusMenu";

export default class CustomerStatusButton extends MenuButton{
    templateHtml(){
        return "<div class='customerStatusButton'>" +
               "  <div class='active'>" +
               "    <%-active%>" +
               "    <div class='downIcon'>&nbsp;</div>" +
               "  </div>" +
               "  <div class='archived'>" +
               "    <%-archived%>" +
               "    <div class='downIcon'>&nbsp;</div>" +
               "  </div>" +
               "</div>"
    } 

    afterRender()
    {
        MenuButton.prototype.afterRender.call(this);
        this.active = false;
        this.inactiveOpenStatus = false
    }

    update()
    {
        MenuButton.prototype.update.call(this);
        this.$el.toggleClass("active", this.active);
        this.$el.toggleClass("archived", !this.active);
        this.$el.toggleClass("disabled", this.disabled);
    }

    messageKeys()
    {
        return {
            active: "customer.edit.status.active",
            archived: "customer.edit.status.archived"
        }
    }

    isActive()
    {
        return this.active;
    }

    setActive(isActive)
    {
        this.active = isActive;
        this.update();
    }

    setInactiveOpenStatus(inactiveOpenStatus) {
        this.inactiveOpenStatus = inactiveOpenStatus
    }

    getMenu()
    {
        var menu = new CustomerStatusMenu(this._getContainerEl()).init()
        menu.setActive(this.active);
        menu.setInactiveOpenStatus(this.inactiveOpenStatus)
        return menu;
    }

    _change(active)
    {
        if (this.active !== active)
        {
            this.active = active;
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/task/CustomerStatusButton.js